import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-slate-50 p-6">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Set a new password</h2>
        <p className="mt-1 text-sm text-slate-500">Choose a strong password of at least 10 characters.</p>
        {!token && <p className="mt-3 text-sm text-rose-600">Missing reset token. Use the link from your email.</p>}
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input
            data-testid="reset-password"
            type="password"
            required
            minLength={10}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="New password"
            className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-teal-600"
          />
          <input
            data-testid="reset-confirm"
            type="password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Confirm password"
            className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-teal-600"
          />
          {err && <div className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{err}</div>}
          <button
            data-testid="reset-submit"
            disabled={busy || !token}
            className="w-full rounded-lg bg-teal-700 py-3 text-sm font-bold text-white hover:bg-teal-800 disabled:opacity-60"
          >
            {busy ? "Please wait…" : "Update password"}
          </button>
          <Link to="/login" className="block text-center text-sm font-semibold text-teal-700 hover:underline">
            Back to sign in
          </Link>
        </form>
      </div>
    </div>
  );
}
